import { render, staticRenderFns } from "./MailNotify.vue?vue&type=template&id=3b3d5020"
import script from "./MailNotify.vue?vue&type=script&lang=js"
export * from "./MailNotify.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports